import { FileDownloadOptionType } from '../../constants/file';

interface FilterObj {
  dateRange?: {
    startDate: Date;
    endDate: Date;
  };
  status?: string[];
  systems?: string[];
  type?: string[];
  platform?: string[];
  invoiced?: string[];
  carrier?: string[];
  service?: string[];
  currentPage?: number;
  perPage?: number;
  searchKey?: string;
  searchValue?: string;
  needAttention?: boolean;
}

interface FileDownloadOptionPropsType {
  isOpen: boolean;
  downloadOption: FileDownloadOptionType;
  title: string;
  handleDownload: (type: string) => void;
}

type ServiceOption = {
  value: string;
  display: string;
};

const getFilteredServiceList = (detailServiceList: any[], carrier: string[]): ServiceOption[] => {
  const list =
    carrier?.length > 0 ? detailServiceList.filter(item => carrier.includes(item?.carrierId?._id)) : detailServiceList;

  return list.map(item => ({
    value: item._id,
    display: item.name,
  }));
};

export { FilterObj, FileDownloadOptionPropsType, getFilteredServiceList };
